import { render, staticRenderFns } from "./PromoButton.vue?vue&type=template&id=b153df7e&scoped=true&"
import script from "./PromoButton.vue?vue&type=script&lang=js&"
export * from "./PromoButton.vue?vue&type=script&lang=js&"
import style0 from "./PromoButton.vue?vue&type=style&index=0&id=b153df7e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b153df7e",
  null
  
)

export default component.exports